// @ts-nocheck
const benefitsModule = benefitsModule ||

  (() => {

    const status = {
      isInitialized: false
    }



    const classNamePrefix = "fm-o-benefits"

    const setUp = () => {
      const elements = document.querySelectorAll(`.${classNamePrefix}`)
      const breakpoints = {
        tablet: document.body.style.getPropertyValue("--breakpoint-tablet"),
        desktop: document.body.style.getPropertyValue("--breakpoint-desktop")
      }

      if (elements.length === 0) return;
      elements.forEach(el => {
        const swiper = el.querySelector('.swiper')
        if (!swiper) return
        const swiperSpaceBetween = window.getComputedStyle(el).getPropertyValue("--swiper-spaceBetween")
        window.swiperObj = new Swiper(swiper, {
          spaceBetween: parseInt(swiperSpaceBetween),
          slidesPerView: 'auto',
          breakpoints: {
            [breakpoints.tablet]: {
              enabled: false
            }
          }
        })
      })
    }

    const init = () => {
      if (status.isInitialized) return
      setUp()
      status.isInitialized = true
    }

    return {
      init
    }
  })()

window.addEventListener('load', benefitsModule.init)